import { Gauge, Home, TreePine } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Badge } from '../ui/badge';

const ICON_MAP = {
  outdoor: TreePine,
  treadmill: Gauge,
  indoor: Home,
};

export default function RecordingModeBadge({ mode, showOutdoor = false, size = 'sm', iconOnly = false }) {
  const { t } = useLanguage();
  if (!mode) return null;
  if (mode === 'outdoor' && !showOutdoor) return null;

  const Icon = ICON_MAP[mode] || TreePine;
  const labelKey =
    mode === 'treadmill'
      ? 'runningExercise.recordingModeTreadmill'
      : mode === 'indoor'
        ? 'runningExercise.recordingModeIndoor'
        : 'runningExercise.recordingModeOutdoor';

  if (iconOnly) {
    return (
      <Icon
        className={size === 'xs' ? 'h-3 w-3 text-muted-foreground' : 'h-3.5 w-3.5 text-muted-foreground'}
        aria-label={t(labelKey)}
      />
    );
  }

  return (
    <Badge variant="outline" className="gap-1 text-[10px] font-normal">
      <Icon className="h-3 w-3" />
      {t(labelKey)}
    </Badge>
  );
}
